/**
 * 企业壳层 path，与 Vite base（import.meta.env.BASE_URL）一致。
 * base 为 /enterprises/ 时不能再写 /enterprises 前缀，否则匹配失败。
 */
export function enterpriseRoutePath(segment: string): string {
  const raw = import.meta.env.BASE_URL || '/';
  const base = raw.endsWith('/') ? raw : `${raw}/`;
  const tail = segment.replace(/^\//, '');

  if (base === '/') {
    return `/enterprises/${tail}`;
  }
  if (base === '/enterprises/' || base.endsWith('/enterprises/')) {
    return `/${tail}`;
  }
  return `/enterprises/${tail}`;
}
